module.exports = __webpack_public_path__ + "assets/img/100702.a00d33a8.svg";